<template>
  <SiteHeader v-if="!enabledIbeMode"/>
  <main>
    <slot/>
  </main>
  <SiteFooter v-if="!enabledIbeMode"/>
  <CookiesNotes />
</template>
<script setup lang="ts">
import { useRoute } from 'vue-router';
import { useBookingStore } from '~/store/booking'
import CookiesNotes from "~/components/CookiesNotes.vue";

const route = useRoute()
const config = useRuntimeConfig()
const configData = config.public
const { $siteConfig } = useNuxtApp()
const { locale } = useI18n()
const enabledIbeMode = ref(configData.ibeMode === 'true')
if (route.query.ibe_mode) {
  enabledIbeMode.value = route.query.ibe_mode === 'true'
}
useHead({
  bodyAttrs: {
    class: 'custom-scrollbar'
  },
  htmlAttrs: {
    lang: locale.value,
  },
});


const brand = ($siteConfig as any).brand
const logo = ($siteConfig as any).logo
const siteHost = ($siteConfig as any).siteName


const agencyHost = configData.siteName ? `https://${configData.siteName}` : ''
const agencyLogo = agencyHost && logo ? `${agencyHost}${logo.startsWith('/') ? '' : '/'}${logo}` : ''

const jsonLd = {
  '@context': 'https://schema.org',
  '@type': 'TravelAgency',
  'name': configData.brand || 'Tripening',
  'description': 'Everything You Need In One Place!',
  'address': 'New York',
  // `siteName` is on runtimeConfig.public, not $siteConfig — reading it off the
  // latter made this render as "undefined/undefined" on every page.
  ...(agencyLogo && { 'image': agencyLogo }),
}

useJsonld(() => (jsonLd as any));
</script>

<style lang="scss" scoped>
main {
  width: 100%;
  max-width: var(--content-max-width);
  margin: 0 auto;
  padding: 0 var(--page-horizontal-padding);
  box-sizing: content-box;

  @media screen and (max-width: 1200px) {
    box-sizing: border-box;
  }
}
</style>
